import React, { useState } from 'react';
import { connect } from 'react-redux';
import { BackButton, hasPermission } from '../../../sc-utilities';
import { updateURL } from '../../../sc-utilities';
import { Paper, Tabs, Tab, withStyles, Typography, Box } from '@material-ui/core';
import ProjectEdit from './ProjectEdit';
import Preset from './Preset';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(5),
        paddingTop: theme.spacing(),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    }
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={props.style}>
            {props.children}
        </Typography>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

const DetailsProjectTab = props => {
    const { classes, theme, project, translations, permissions } = props;
    const [tabValue, setTabValue] = useState(getTabValue());

    const handleChange = (_event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <>
            <Paper className={classes.root}>
                {BackButton(translations)}
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    {hasPermission(permissions, 'project_load') ? <Tab label={translations['details'] || "Details"} /> : null}
                    {hasPermission(permissions, 'project_load') ? <Tab label={translations['preset'] || "Preset"} /> : null}

                </Tabs>
            </Paper>


            {hasPermission(permissions, 'project_load') ?
                <TabPanel index={0} value={tabValue} style={{ padding: 3 * 3 }}>
                    <TabContainer dir={theme.direction}>
                    </TabContainer><ProjectEdit /> </TabPanel> : null}
            {hasPermission(permissions, 'project_load') ?
                <TabPanel index={1} value={tabValue} style={{ padding: 3 * 3 }}>
                    <TabContainer dir={theme.direction}><Preset project={project} />
                    </TabContainer> </TabPanel> : null}        </>
    );
}

const mapStateToProps = state => {
    return {
        project: state?.client?.projects?.loaded,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};


export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(DetailsProjectTab));